export const deviceCredentialsMessages = {
  en: {
    passwordsSubtitle: 'Stored credentials',
    help: 'IP Fabric interacts with the network infrastructure devices by running show commands through CLI using SSH or Telnet. If more than one credential is specified, a top down algorithm is used when trying to login to a network device. you can easily change credentials priority using drag and drop.',
    tableBoxTitle: 'List of stored username/password combinations',
    btnAdd: 'Add new',
    btnUseGlobalSettings: 'Override with global settings',
    userPwd: {
      username: 'Username',
      password: 'Password',
      network: 'Use in subnet',
      notes: 'Note',
      useInSyslog: 'Use for configuration management',
      btnSave: 'Save',
      boxTitle: 'New username/password combination',
      placeholder: {
        username: 'username',
      },
      validation: {
        required: 'Required',
        invalidNetwork: 'Invalid CIDR format',
      },
    },
    table: {
      username: { name: 'Username', help: '' },
      expire: { name: 'Expiration date', help: '' },
      password: { name: 'Password', help: '' },
      syslog: { name: 'Use for configuration management', help: '' },
      notes: { name: 'Notes', help: '' },
      network: { name: 'Use in subnets', help: '' },
      includeNetworks: { name: 'Use in subnets', help: '' },
      excludeNetworks: { name: "Don't use in subnets", help: '' },
      action: { name: 'Action', help: '' },
    },
    yes: 'Yes',
    no: 'No',
    enableModeSubtitle: 'Stored passwords',
    enableModeHelp:
      'Privileged credentials are generally necessary only for configuration backup, however some platforms require privileged credentials to access basic network state information, such as MST spanning tree state or 802.1X session information.',
    validation: {
      pwdListEmpty: 'Password list must not be empty.',
    },
    enablePwd: {
      password: 'Password',
      notes: 'Notes',
      btnSave: 'Save',
      boxTitle: 'New password',
      placeholder: {
        username: 'username',
      },
      validation: {
        required: 'Password is empty',
      },
    },
    tableEnableBoxTitle: 'List of stored enable passwords',
    never: 'Never',
    editUserDialogue: {
      addTitle: 'Add new CLI credential',
      btnCancel: 'Cancel',
      btnSave: 'Save',
      editTitle: 'Edit CLI credential',
      expire: 'Expiration date',
      expirePlaceholder: 'Select date',
      network: 'Use in subnets',
      networkPlaceholder: 'Insert CIDR prefix',
      excludeNetworks: 'Don’t use in subnets',
      notes: 'Notes',
      password: 'Password',
      retypePassword: 'Retype Password',
      syslog: 'Use for configuration management',
      username: 'Username',
      validation: {
        nonPrintableAscii: 'Only ASCII printable characters are allowed',
        invalidNet: "{net} isn't valid CIDR format",
        invalidExpireFormat: 'Expiration must be in format YYYY-MM-DD',
        passwordMatch: 'Passwords do not match',
        excludeOverlap:
          'Overlapping between Networks to exclude and Networks for include',
        required: 'Required',
        invalidNetwork: 'Invalid CIDR format',
      },
    },
    enablePwdDialogue: {
      addTitle: 'Add enable password',
      editTitle: 'Edit enable password',
      username: 'Username',
      expire: 'Expiration date',
      expirePlaceholder: 'Select date',
      notes: 'Notes',
      password: 'Password',
      retypePassword: 'Retype Password',
      includeNetworks: 'Use in subnets',
      networksPlaceholder: 'Insert CIDR prefix',
      excludeNetworks: 'Don’t use in subnets',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      validation: {
        nonPrintableAscii: 'Only ASCII printable characters are allowed',
        invalidExpireFormat: 'Expiration must be in format YYYY-MM-DD',
        invalidNet: "{net} isn't valid CIDR format",
        passwordMatch: 'Passwords do not match',
        excludeOverlap:
          'Overlapping between Networks to exclude and Networks for include',
        required: 'Required',
      },
    },
    confirmDialog: {
      header: 'Update authentication settings from global settings',
      subHeader: 'Overwrite current settings?',
      btnConfirm: 'Overwrite',
      btnSecondaryConfirm: 'Cancel',
    },
    settingsDoesNotDiffer:
      'Current settings does not differ from global settings',
    request: {
      authenticationConflict: 'The given credentials already exists',
      authenticationConflictEnable: 'The given credentials already exists',
      globalSettingsApplied: 'Global settings applied',
    },
    credentialsList: {
      allowedInSubnets: 'Allowed in subnets',
      noSubnets: 'None',
      deniedInSubnets: 'Denied in subnets',
      expires: 'Expires',
      never: 'Never',
      useForConfigMgmt: 'Use for configuration management',
      yes: 'Yes',
      no: 'No',
      noEnablePasswords: 'No stored passwords',
      noPasswords: 'No stored credentials',
      showAllPasswords: 'Show all ({count}) credentials',
      showAllEnablePasswords: 'Show all ({count}) passwords',
      usedIn: 'Used in',
      configMgmt: 'Config management',
    },
  },
};
